import get from 'lodash.get';

export const querySettings = {
  page: 1,
  queryLimit: 4,
  shownOnFronts: true,
};

export const getLiveBlogArticleId = (packageData) => {
  const item = get(packageData, 'items[0]') || {};
  const { id } = item;
  if (!id) return null;
  return String(id).replace('cna', '');
};

export default {
  querySettings,
  getLiveBlogArticleId,
};
